import Container from '@components/global/Container';
import { LinkTile, PageType } from '@adapters/prismic/types/slices';
import LinkTilesItem from './LinkTIlesItem';

import styles from './LinkTiles.module.scss';

export interface LinkTilesProps {
  items: LinkTile[];
  trackPromos?: boolean;
  pageType: PageType;
  sliceIndex: number;
}

const LinkTiles = ({
  items,
  trackPromos,
  pageType,
  sliceIndex,
}: LinkTilesProps) => (
  <Container>
    <div className={styles.linkTileContainer}>
      {items.map(({ tile_image, tile_link }, i) => (
        <LinkTilesItem
          image={tile_image}
          link={tile_link}
          positionWithinSlice={i}
          trackPromos={trackPromos}
          pageType={pageType}
          sliceIndex={sliceIndex}
        />
      ))}
    </div>
  </Container>
);

export default LinkTiles;
